export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M14 19.5v-3h-4v3zm-9-12h5v3h4v-3h5v-3H5zm16 7v-2H3v2z\"/>"
};